import { Directive } from '@angular/core';

@Directive({
    selector: '[qpxDataList]',
    host: {
        class: 'min-h-0 min-w-0',
        'aria-label': 'Data list',
    },
})
export class QpxDataList {}
